import { defaultMemoize } from 'reselect';

import { LoginUrls, SignInUrlBuilder } from '@tableau/shared-urls';

import { Location } from '../../../common/react/Location';
import { queryStringSelector } from '../../selectors/SiteUrlsSelectors';

export class LoginUrlsWrapper {
  private static memoizedCreateInstance = defaultMemoize((queryString: string) => new LoginUrls(queryString));

  public static getInstance(): LoginUrls {
    const queryString = queryStringSelector();
    return LoginUrlsWrapper.memoizedCreateInstance(queryString);
  }

  public static navigateToSignIn(queryParams: SignInUrlBuilder.QueryParams): void  {
    const url = LoginUrlsWrapper.getInstance().signinUrl(queryParams);
    Location.instance.setUrl(url);
  }

  public static navigateToLoginSitePicker(): void {
    const url = LoginUrlsWrapper.getInstance().siteUrl();
    Location.instance.setUrl(url);
  }

  public static navigateToSignInErrorCodeFromSiteSwitch(errorCode: string): void {
    const url = LoginUrlsWrapper.getInstance().signinErorrCodeFromSiteSwitchUrl(errorCode);
    Location.instance.setUrl(url);
  }

  public static navigateToSignInErrorCode(errorCode: string): void {
    const url = LoginUrlsWrapper.getInstance().signinErorrCodeUrl(errorCode);
    Location.instance.setUrl(url);
  }

  public static navigateToPasswordResetWithUsername(username: string): void {
    const url = LoginUrlsWrapper.getInstance().passwordResetWithUsernameUrl(username);
    Location.instance.setUrl(url);
  }
}
